module.exports = __webpack_public_path__ + "img/logoonly.78d1ea08.png";